import { PageComposerModel } from 'common/models/page-composer.model';

export const globalPageConfigs: Pick<PageComposerModel, 'columns' | 'gap'> = {
  columns: 12,
  gap: {
    rows: 16,
    columns: 16,
  },
};
